// Порядок не менять, если не было изменений в интерфейсе
export const scopeMap = {
  INFORMATION_HOUSEHOLD: 'info',
  MEMBERS: 'members',
  ALL_LANDS: 'lands',
  ALL_ANIMALS_COUNT: 'animals',
  ALL_MACHINE_COUNT: 'machines',
  HOME_INFO: 'home',
  MONEY_PLANTS: 'plants',
  ALL_ANIMALS_MONEY: 'livestock',
  ALL_ECONOMIC: 'economic',
  SPOKS: 'spoks',
  CHANGES: 'changes',
};

export const scopeMapValues = Object.values(scopeMap);

export const getNextScope = (currentValue: string) => {
  const currentIndex = scopeMapValues.indexOf(currentValue);

  if (currentIndex === -1) return scopeMap.INFORMATION_HOUSEHOLD;

  // Определяем следующий индекс с учетом циклического перехода
  const nextIndex = (currentIndex + 1) % scopeMapValues.length;
  return scopeMapValues[nextIndex];
};
